export default "__VITE_ASSET__B_TisG3f__"